<!--suppress ALL -->
<template>
  <section>
    <div v-if="panel != 'tab-5'">
      <q-footer elevated>
        <q-toolbar>
          <div class="flex col-12 row items-center justify-between">
            <div
              class="col-8 div-progress q-pa-sm justify-center flex items-center"
            >
              <q-linear-progress
                size="md"
                :value="progressBar"
                color="red-9"
                rounded
              />
            </div>
            <div
              class="col-4 justify-center flex items-center"
              v-if="panel == 'tab-4'"
            >
              <q-btn
                unelevated
                rounded
                color="red-9"
                @click="finishAttendance"
                label="Concluir"
              />
            </div>
            <div
              class="col-2 div-btn-next justify-center flex items-center"
              v-else
            >
              <q-btn
                round
                color="red-9"
                @click="addValueBarProgressAndAlterTab()"
                icon="arrow_forward"
              />
            </div>
          </div>
        </q-toolbar>
      </q-footer>
    </div>
  </section>

  <q-page-container>
    <q-page class="q-pa-md">
      <section class="section-service">
        <q-option-group
          hidden
          v-model="panel"
          inline
          :options="[
            { label: 'Tab-1', value: 'tab-1' },
            { label: 'Tab-2', value: 'tab-2' },
            { label: 'Tab-3', value: 'tab-3' },
            { label: 'Tab-4', value: 'tab-4' },
            { label: 'Tab-5', value: 'tab-5' },
          ]"
        />

        <q-tab-panels v-model="panel" class="panel-services">
          <q-tab-panel name="tab-1" class="col-12 row items-center">
            <div class="col-12 row title-page">Dados do técnico</div>
            <div class="group-input col-12 row q-mt-lg">
              <label for="number_phone">Telefone (DDD + número)</label>
              <q-input
                :ref="refsFramework.numberPhoneRef"
                id="number_phone"
                class="col-12 q-mt-sm"
                bg-color="white"
                color="red-9"
                v-model="contract.numberPhone"
                dense
                outlined
                mask="(##) #####-####"
                placeholder="(##) #####-####"
                unmasked-value
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                  (val) =>
                    val.length > 10 || 'O número informado não parece valido.',
                ]"
                lazy-rules
                :disable="disableInputPhoneNumber"
              >
                <template v-slot:after>
                  <q-btn
                    round
                    color="red-9"
                    icon="edit"
                    @click="disableInputPhoneNumberFunction"
                  />
                </template>
              </q-input>
            </div>
            <div class="group-input col-12 row q-mt-lg">
              <label for="credenciada">Credenciada</label>
              <q-select
                id="accredited"
                :ref="refsFramework.accreditedRef"
                class="col-12 q-mt-sm"
                outlined
                dense
                v-model="contract.accredited"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="optionsItens.optionsAccredited"
                option-value="value"
                option-label="text"
                @filter="filterAccredited"
                bg-color="white"
                :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
                lazy-rules
                :disable="disableInputAccredited"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      Sem resultado
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:after>
                  <q-btn
                    round
                    color="red-9"
                    icon="edit"
                    @click="disableInputAccreditedFunction"
                  />
                </template>
              </q-select>
            </div>
          </q-tab-panel>

          <q-tab-panel name="tab-2" class="col-12 row items-center">
            <div class="col-12 row title-page">Dados do contrato</div>
            <div class="group-input col-12 row q-mt-lg flex justify-between">
              <div class="col-4">
                <label class="text-subtitle2" for="code_city"
                  >Cód. da Cidade</label
                >
                <q-select
                  id="code_city"
                  class="col-12 q-mt-sm"
                  outlined
                  dense
                  :ref="refsFramework.codeCityRef"
                  v-model="contract.codeCity"
                  color="red-9"
                  @filter="filterCodCities"
                  use-input
                  hide-selected
                  fill-input
                  input-debounce="0"
                  :options="optionsItens.optionsCodCity"
                  @update:model-value="getCityByCodeCity()"
                  option-value="value"
                  option-label="value"
                  bg-color="white"
                  :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>
              <div class="col-7">
                <label for="contract_number">Nº do Contrato</label>
                <q-input
                  id="contract_number"
                  :ref="refsFramework.contractNumberRef"
                  v-model="contract.contractNumber"
                  class="col-4 q-mt-sm"
                  bg-color="white"
                  color="red-9"
                  maxlength="9"
                  dense
                  outlined
                  mask="#########"
                  unmasked-value
                  placeholder="000000000"
                  :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>
            </div>
            <div
              class="col-12 group-input"
              v-if="parseInt(route.params.type_attendance) == 4"
            >
              <label class="text-subtitle2" for="contract_wo"
                >Número da WO</label
              >
              <q-input
                id="contract_wo"
                :ref="refsFramework.numberWo"
                v-model="contract.numberWo"
                class="col-4 q-mt-sm"
                bg-color="white"
                color="red-9"
                dense
                outlined
                :rules="[(val) => val.trim() != '' || 'Campo Obrigatório']"
                lazy-rules
              />
            </div>
            <div class="group-input col-12 row q-mt-md">
              <label for="city">Cidade</label>
              <q-select
                id="city"
                class="col-12 q-mt-sm"
                outlined
                dense
                :ref="refsFramework.cityRef"
                v-model="contract.city"
                color="red-9"
                @filter="filterCities"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="optionsItens.optionsCity"
                option-value="value"
                option-label="text"
                bg-color="white"
                :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
                lazy-rules
              />
            </div>
          </q-tab-panel>

          <q-tab-panel name="tab-3" class="col-12 row items-center">
            <div class="col-12 row title-page flex justify-between">
              solicitações
              <span>Tempo para tabular {{ timerAttendance.timer }}</span>
            </div>
            <div class="div-requests col-12 row flex">
              <card-requests-os
                v-for="item in contract.osRequests"
                :check="item.check"
                :os-number="item.osNumber"
                :type-os="item.typeOS"
                :key="item.onject_id"
                :redo-from-drop="item.redoFromDrop"
                @edit="editSchemaRequest(item)"
                @openConfirm="
                  modalDialogConfirmarDeleteSchemaOsRequest(
                    item.object_id,
                    item.osNumber
                  )
                "
              />
            </div>
            <div class="col-12 row flex justify-end q-mt-md">
              <q-btn
                unelevated
                text-color="red-9"
                @click="addNewSchemaRequest"
                size="md"
                icon="add"
                label="Nova solicitação"
              />
            </div>
          </q-tab-panel>
          <q-tab-panel name="tab-4" class="col-12 row items-center">
            <div class="col-12 row title-page">Informações finais</div>

            <div class="col-12 row q-mt-sm">
              <label
                >Insira os horários de início e conclusão do atendimento.</label
              >
            </div>
            <div class="col-12 q-mt-lg">
              <label for="start">Início</label>
              <q-input
                id="start"
                :ref="refsFramework.initialTimeRef"
                v-model="contract.initialTime"
                bg-color="white"
                class="col-12 q-mt-sm"
                color="red-9"
                type="time"
                dense
                outlined
                :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
                lazy-rules
              />
            </div>
            <div class="col-12 q-mt-lg">
              <label for="conclusion_time">Conclusão</label>
              <q-input
                id="conclusion_time"
                :ref="refsFramework.conclusionTimeRef"
                v-model="contract.conclusionTime"
                bg-color="white"
                class="col-12 q-mt-sm"
                color="red-9"
                type="time"
                dense
                outlined
                :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
                lazy-rules
              />
            </div>

            <div class="group-input col-12 row q-mt-md">
              <label for="type-os">Atendimento Fora TOA?</label>
              <div class="col-12 row flex justify-around">
                <q-radio
                  keep-color
                  v-model="contract.serviceOutsideToa"
                  :val="1"
                  size="lg"
                  label="Sim"
                  color="red-6"
                />
                <q-radio
                  keep-color
                  v-model="contract.serviceOutsideToa"
                  :val="0"
                  size="lg"
                  label="Não"
                  color="red-6"
                />
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="tab-5" class="col-12 row items-center">
            <FormOsLowProductionWithoutMove
              :itemOsContract="itemOsContract"
              :optionsWriteOffCode="optionsItens.optionsWriteOffCode"
              :optionsTypeOS="optionsItens.optionsTypeOS"
              :listWriteOffCode="listWriteOffCode"
              :listTypeOS="listTypeOS"
              @saveSchemaRequest="
                (requestData) => saveSchemaRequest(requestData)
              "
              @clearSchemaRequest="clearSchemaRequest"
              @removeEdit="() => returnSolicitationTab()"
            />
          </q-tab-panel>
        </q-tab-panels>
      </section>
    </q-page>
  </q-page-container>
</template>

<script setup>
import moment from "moment-timezone";
import { useQuasar, date } from "quasar";

import { ref, onMounted, computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import LowProductionServices from "../../services/LowProductionServices";

import CardRequestsOs from "@/components/CardRequestsOs";
import DialogCardsOsAvailableReplicate from "@/components/DialogCardsOsAvailableReplicate";
import FormOsDesobstructionRequest from "@/components/RequestOsForms/FormOsDesobstructionRequest";
import FormOsProductionRquest from "@/components/RequestOsForms/FormOsProductionRquest";
import FormOsLowProductionWithoutMove from "@/components/RequestOsForms/FormOsLowProductionWhitoutMove.vue";

import createJsonProductionOsRequest from "../../utils/ResquestOsForms/createJsonOsRequest";
import createJsonDesobstructionOsRequest from "../../utils/ResquestOsForms/createJsonOsRequestDesobstruiction";

const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const store = useStore();
const lowProductionServices = new LowProductionServices();

let progressBar = ref(0.25);
let tabindex = ref(1);
let panel = ref("tab-1");
let confirmationReplicateWriteOffCode = ref(false);
let modalReplicateWriteOffCode = ref(false);
let writeOffCodeDefault = ref("");
let disableInputPhoneNumber = ref(false);
let disableInputAccredited = ref(false);
let inputTeamVisible = computed(
  () =>
    contract.accredited == "TECNICO PROPRIO" ||
    contract.accredited.value == "TECNICO PROPRIO"
);
let escalation = ref({});
const listCities = ref([]);
const listTypeOS = ref([]);
const listWriteOffCode = ref([]);
const listAccrediteds = ref([]);
let timerAttendance = reactive({
  minutes: 4,
  secondes: 0,
  timer: "04:00",
  stopTime: false,
});
let setIntervat;
let excute = ref(true);
let team = ref("");

let contract = reactive({
  accredited: "",
  city: "",
  numberPhone: "",
  codeCity: "",
  initialTime: "",
  conclusionTime: "",
  contractNumber: "",
  serviceOutsideToa: 0,
  osRequests: [],
  dateStartedAttendance: "",
  dateFinishedAttendance: "",
  numberWo: "",
});

let itemOsContract = reactive({
  data: {},
});

let refsFramework = {
  teamRef: ref(""),
  numberPhoneRef: ref(""),
  accreditedRef: ref(""),
  codeCityRef: ref(""),
  contractNumberRef: ref(""),
  cityRef: ref(""),
  typeOSRef: ref(""),
  osNumberRef: ref(""),
  writeOffCodeRef: ref(""),
  conclusionTimeRef: ref(""),
  initialTimeRef: ref(""),
  numberWo: ref(""),
};

const optionsItens = reactive({
  optionsAccredited: listAccrediteds,
  optionsCity: listCities,
  optionsCodCity: listCities,
  optionsTypeOS: listTypeOS,
  optionsWriteOffCode: listWriteOffCode,
});

function startTimerFilledRequest() {
  contract.dateStartedAttendance = moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");
  if (!timerAttendance.stopTime) {
    setIntervat = setInterval(() => {
      if (route.name != "low-production") {
        clearInterval(setIntervat);
        return;
      }
      if (tabindex.value != 3 && tabindex.value != 5) {
        return;
      }
      if (timerAttendance.secondes > 0) {
        timerAttendance.secondes--;
      } else {
        if (timerAttendance.minutes > 0) {
          timerAttendance.minutes--;
          timerAttendance.secondes = 60;
        }
      }
      if (timerAttendance.secondes == 0 && timerAttendance.minutes == 0) {
        _modalDialogConfirmRedirectByTimeoutDefaultRequest();
      }
      setTimer(timerAttendance.minutes, timerAttendance.secondes);
    }, 1000);
  }
}

function setTimer(minutes, secondes) {
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (secondes < 10) {
    secondes = "0" + secondes;
  }
  timerAttendance.timer = minutes + ":" + secondes;
}

function openConfirmationReplicateWriteOffCode() {
  if (requestData.writeOffCode == "") {
    confirmationReplicateWriteOffCode.value = false;
    $q.notify({
      message: "Selecione pelo menos um código baixa antes de replicar.",
      color: "red-9",
      position: "top",
    });
    return;
  }

  if (confirmationReplicateWriteOffCode.value == true) {
    modalReplicateWriteOffCode.value = true;
  } else {
    cancelReplicate();
  }
}

function replicateWriteOffCode() {
  for (let item of contract.osRequests) {
    if (item.osNumber !== requestData.osNumber && item.replicate === true) {
      item.writeOffCode = requestData.writeOffCode;
    }
  }
  confirmationReplicateWriteOffCode.value = true;
  modalReplicateWriteOffCode.value = false;
}

function cancelReplicate() {
  confirmationReplicateWriteOffCode.value = false;
  for (let item of contract.osRequests) {
    item.replicate = false;
  }
}

function _getCitiesActives() {
  lowProductionServices.getCitiesActives().then((response) => {
    listCities.value = response;
  });
}

function _getTypeOsActives() {
  lowProductionServices.getTypeOsActives().then((response) => {
    listTypeOS.value = response;
  });
}

function _getWriteOffCodeActives() {
  let typeOs = getTypeOSbyCode(route.params.type_attendance);
  //lowProductionServices.getWriteOffCodeActives()
  lowProductionServices
    .getWriteOffCodeActivesByType(typeOs)
    .then((response) => {
      listWriteOffCode.value = response;
    });
}

function _getAccreditedsActives() {
  lowProductionServices.getAccreditedsActives().then((response) => {
    listAccrediteds.value = response;
  });
}

function getCityByCodeCity() {
  lowProductionServices
    .getCityByCodeCity(contract.codeCity.value)
    .then((response) => {
      contract.city = {
        text: response.cidade,
        value: response.codcidadenetsms,
      };
    });
}

function addValueBarProgressAndAlterTab() {
  const VALUE_MAX_BAR_PROGRESS = 1;
  const VALUE_ADD_PROGRESS = 0.25;
  if (progressBar.value != VALUE_MAX_BAR_PROGRESS) {
    let validateIfChangeTab = _changeTab();
    if (validateIfChangeTab) {
      progressBar.value += VALUE_ADD_PROGRESS;
    }
  }
}

function returnSolicitationTab() {
  const VALUE_MIN_BAR_PROGRESS = 0.25;
  const VALUE_REMOVE_PROGRESS = 0.25;
  const VALUE_TAB_INDEX = 2;

  if (progressBar.value > VALUE_MIN_BAR_PROGRESS) {
    tabindex.value -= VALUE_TAB_INDEX;
    panel.value = "tab-" + tabindex.value;
    //progressBar.value -= VALUE_REMOVE_PROGRESS;
  }
}

function _changeTab() {
  const VALUE_INCREMENT_ID_TAB = 1;
  const STRING_ID_TAB = "tab-";

  let validateFieldsFilled = _validateFieldsTabs(tabindex.value);
  if (validateFieldsFilled) {
    if (
      tabindex.value == 1 &&
      (!disableInputPhoneNumber.value ||
        !disableInputAccredited.value ||
        team.value != store.state.team)
    ) {
      if (store.state.numberPhone == "") {
        _saveTechnicianPhoneNumberAndAccredited();
      } else {
        _editTechnicianPhoneNumberAndAccredited();
      }
    }

    if (tabindex.value == 2) {
      contract.dateStartedAttendance = moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");

      startTimerFilledRequest();
    }
    if (tabindex.value == 3) {
      contract.dateFinishedAttendance = moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");
      timerAttendance.stopTime = true;
    }

    tabindex.value += VALUE_INCREMENT_ID_TAB;
    panel.value = STRING_ID_TAB + tabindex.value;

    return true;
  }
}

function _editTechnicianPhoneNumberAndAccredited() {
  let TechnicianData = {
    login_tecnico: store.state.technicianLogin.toString(),
    telefone: contract.numberPhone,
    equipe: team.value,
    credenciada:
      contract.accredited.value == null
        ? contract.accredited
        : contract.accredited.value,
  };
  lowProductionServices.editTechnicianPhoneNumberAndAccredite(TechnicianData);
}

function _saveTechnicianPhoneNumberAndAccredited() {
  let TechnicianData = {
    login_tecnico: store.state.technicianLogin,
    telefone: contract.numberPhone,
    credenciada: contract.accredited.value,
    nome_tecnico: store.state.technicianName,
    equipe: team.value,
  };
  lowProductionServices.saveTechnicianPhoneNumberAndAccredite(TechnicianData);
}

function _validateFieldsTabs(tabindex) {
  if (tabindex == 1) {
    // if (inputTeamVisible.value) {
    //   if (!refsFramework.teamRef.value.validate()) return false;
    // }
    if (
      !refsFramework.numberPhoneRef.value.validate() ||
      !refsFramework.accreditedRef.value.validate()
    )
      return false;
    return true;
  }
  if (tabindex == 2) {
    var regexContract = /^(\d)\1+$/;
    var regexWo = /^(\d+)|(\d+)$/;

    if (
      !refsFramework.codeCityRef.value.validate() ||
      !refsFramework.contractNumberRef.value.validate() ||
      !refsFramework.cityRef.value.validate()
    )
      return false;

    if (regexContract.test(contract.contractNumber)) {
      $q.notify({
        message:
          "O número de contrato não poder ter uma cadeia do mesmo caracter.",
        color: "red-9",
        position: "top",
      });
      return false;
    }

    if (parseInt(route.params.type_attendance) == 4) {
      if (!refsFramework.numberWo.value.validate()) return false;

      console.log(regexWo.test(contract.numberWo));
      if (!regexWo.test(contract.numberWo)) {
        $q.notify({
          message: "O número da WO permite apenas números e |.",
          color: "red-9",
          position: "top",
        });
        return false;
      }
    }

    return true;
  }
  if (tabindex == 3) {
    let checkRequestChecked = false;
    for (let obj of contract.osRequests) {
      if (!obj.check) {
        checkRequestChecked = false;
        $q.notify({
          message:
            "Não é possivel continuar sem ter no mínimo uma solicitação devidamente preenchida.",
          color: "red-9",
          position: "top",
        });
        return;
      } else {
        checkRequestChecked = true;
      }
    }
    return checkRequestChecked;
  }
  if (tabindex == 4) {
    let hoursNow = new Date().getHours();
    let conclusionTimeHours = contract.conclusionTime.split(":")[0];
    let initialTimeHours = contract.initialTime.split(":")[0];

    if (conclusionTimeHours > hoursNow || initialTimeHours > hoursNow) {
      $q.notify({
        message: "Não é permitido selecionar uma hora futura.",
        color: "red-9",
        position: "top",
      });
      return false;
    }

    if (
      !refsFramework.conclusionTimeRef.value.validate() ||
      !refsFramework.initialTimeRef.value.validate()
    )
      return false;
    return true;
  }
}

function filterAccredited(val, update) {
  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsAccredited = listAccrediteds.value.filter(
      (v) => v.text.toLowerCase().indexOf(needle) > -1
    );
  });
}

function filterCities(val, update) {
  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsCity = listCities.value.filter(
      (v) => v.text.toLowerCase().indexOf(needle) > -1
    );
  });
}

function filterCodCities(val, update) {
  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsCodCity = listCities.value.filter(
      (v) => v.value.toLowerCase().indexOf(needle) > -1
    );
  });
}

function filterTypeOS(val, update) {
  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsTypeOS = listTypeOS.value.filter(
      (v) => v.text.toLowerCase().indexOf(needle) > -1
    );
  });
}

function filterWriteOffCode(val, update) {
  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsWriteOffCode = listWriteOffCode.value.filter(
      (v) => v.text.toLowerCase().indexOf(needle) > -1
    );
  });
}

function editSchemaRequest(item) {
  panel.value = "tab-5";
  tabindex.value = 5;
  itemOsContract.data = item;
}

function clearSchemaRequest(object = null) {
  if (object !== null) {
    deleteSchemaRequest(object.object_id);
    object.redoFromDrop = true;
    contract.osRequests.push(object);
  }
  panel.value = "tab-3";
  tabindex.value = 3;
}

function _createInitSchemaRequest() {
  for (const item of store.state.osNumbers.split(",")) {
    let schemaRequest = {
      object_id: _generateUUIDv4(),
      osNumber: item,
      typeOS: "",
      statusOS: 1,
      writeOffCode: writeOffCodeDefault == "" ? "" : writeOffCodeDefault,
      observation: "",
      check: false,
      replicate: false,
      source: "NetSMS",
      redoFromDrop: false,
    };
    contract.osRequests.push(schemaRequest);
  }
}

function deleteSchemaRequest(object_id) {
  let newObjectOSRequest = contract.osRequests.filter((obj) => {
    return obj.object_id != object_id;
  });

  contract.osRequests = newObjectOSRequest;
}

function saveSchemaRequest(requestData) {
  deleteSchemaRequest(requestData.object_id);
  contract.osRequests.push(requestData);
  clearSchemaRequest();
}

function addNewSchemaRequest() {
  let schemaRequest = {
    object_id: _generateUUIDv4(),
    osNumber: "",
    typeOS: "",
    statusOS: 1,
    writeOffCode: writeOffCodeDefault == "" ? "" : writeOffCodeDefault,
    observation: "",
    check: false,
    replicate: false,
    source: "Vega",
    redoFromDrop: false,
  };

  contract.osRequests.push(schemaRequest);
}

function finishAttendance() {
  if (!_validateFieldsTabs(tabindex.value)) return false;

  _createJsonOsRequestFinishAttendance();
  lowProductionServices
    .finishService(contract)
    .then((response) => {
      _generateNewTokenWithDataTechnicianBaseAndRedirectServiceHistory();
    })
    .catch((error) => {
      _generateNewTokenWithDataTechnicianBaseAndRedirectServiceHistory();
    });
}

function _createJsonOsRequestFinishAttendance() {
  let ATTENDANCE_LOW_PRODUCTIVE = parseInt(route.params.type_attendance);
  let createJsonOsRequest = null;

  contract.codeCity = contract.codeCity.value;
  contract.typeAttendance = ATTENDANCE_LOW_PRODUCTIVE;
  (contract.accredited =
    contract.accredited.value == null
      ? contract.accredited
      : contract.accredited.value),
    delete contract.city;

  if (
    parseInt(route.params.type_attendance) == 1 ||
    parseInt(route.params.type_attendance) == 3
  ) {
    createJsonOsRequest = createJsonProductionOsRequest;
  }

  if (parseInt(route.params.type_attendance) == 4) {
    createJsonOsRequest = createJsonDesobstructionOsRequest;
  }

  for (let i = 0; i < contract.osRequests.length; i++) {
    contract.osRequests[i] = createJsonOsRequest(contract.osRequests[i]);
  }
}

function _generateUUIDv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

function modalDialogConfirmarDeleteSchemaOsRequest(object_id, osNumber) {
  $q.dialog({
    title: `Deletar OS ${osNumber}`,
    message: `Atenção! Após deletar a OS, não há uma forma de reverter. Tem certeza que deseja deletar a OS selecionada?`,
    cancel: true,
    persistent: true,
    position: "bottom",
  })
    .onOk(() => {
      deleteSchemaRequest(object_id);
    })
    .onCancel(() => {});
}

function _modalDialogConfirmRedirectByTimeoutDefaultRequest() {
  if (excute.value == true) {
    $q.dialog({
      title: `Tempo excedido`,
      message: `O seu tempo para realizar a tabulação foi excedido`,
      cancel: false,
      persistent: true,
      position: "bottom",
    }).onOk(() => {
      _recoveredTokenAndRedirectServiceHistory();
    });

    excute.value = false;
  }
}

function _recoveredTokenAndRedirectServiceHistory() {
  let token = localStorage.getItem("access_token");
  let link = `${window.location.origin}/service-history?access_token=${token}`;
  contract.dateStartedAttendance = "";
  window.location = link;
}

function _generateNewTokenWithDataTechnicianBaseAndRedirectServiceHistory() {
  let data = {
    loginTecnico: store.state.technicianLogin.toString(),
    nomeTecnico: store.state.technicianName.toString(),
    contrato: "",
    nomeLider1: "",
    telefoneLider1: "",
    addressCity: "",
    osNumbers: [],
    epoName: "",
    osDescription: "",
    nomeLider2: "",
    nomeLider3: "",
    nomeLider4: "",
    telefoneLider2: "",
    telefoneLider3: "",
    telefoneLider4: "",
  };

  lowProductionServices
    .generateNewTokenWithDataTechnicianBaseAndRedirectServiceHistory(data)
    .then((response) => {
      localStorage.removeItem("vuex");
      window.location = response.urlredirect;
    })
    .catch((error) => {
      $q.notify({
        message:
          "Erro ao gerar link de retorno.. por favor reconect ao menu manualmente",
        color: "red-9",
        position: "top",
      });
    });
}

function _getDefaultTechnicianData() {
  contract.accredited = store.state.accredited;
  contract.numberPhone = store.state.numberPhone;
  contract.contractNumber = store.state.contractNumber;
  team.value = store.state.team;
  if (store.state.addressCity != "") {
    lowProductionServices
      .getCodeCityByName(store.state.addressCity)
      .then((response) => {
        contract.codeCity = {
          text: response.cidade,
          value: response.codcidadenetsms,
        };
        contract.city = {
          text: response.cidade,
          value: response.codcidadenetsms,
        };
      });
  }
  if (store.state.osDescription != "") {
    lowProductionServices
      .getTypeOsByName(store.state.osDescription)
      .then((response) => {
        for (let i = 0; i < contract.osRequests.length; i++) {
          contract.osRequests[i].typeOS = {
            text: response.tipo,
            value: response.id_tipoos,
          };
        }
      });
  }
  if (store.state.numberPhone != "") {
    disableInputPhoneNumber.value = true;
  }
  if (store.state.accredited != "") {
    disableInputAccredited.value = true;
  }
}

function disableInputPhoneNumberFunction() {
  disableInputPhoneNumber.value = false;
}

function disableInputAccreditedFunction() {
  disableInputAccredited.value = false;
}

computed(() => {
  setTimer(timerAttendance.minutes, timerAttendance.secondes);
});

onMounted(() => {
  _getCitiesActives();
  _getTypeOsActives();
  _getAccreditedsActives();
  _getWriteOffCodeActives();
  _createInitSchemaRequest();
  _getDefaultTechnicianData();
});
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.q-page-container {
  padding-bottom: 0px !important;
}

.label-checkbox-confirm {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.01em !important;
  color: #999999 !important;
}

footer {
  background: #ffffff;
  height: 12vh;

  .q-toolbar {
    height: 12vh;
  }

  .div-progress {
    height: 8vh;
  }

  .div-btn-next {
    height: 8vh;
  }
}

.section-service {
  .panel-services {
    background: transparent !important;
    overflow: hidden !important;

    .title-page {
      font-weight: bold;
      font-size: 18px;
      line-height: 19px;
      text-transform: uppercase;
      color: #e2262d;
    }

    .group-input {
      label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .label-requests-number {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .label-requests-description {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>
